<template>
    <div class="pending-list">
        <dy-table :columns="columns" :table-data="tableData" ref="pendingTable" v-loading="tableLoading" :total="tTotal"
            :page-num="10" :page-size="10" @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>

        <!-- 反馈信息 -->
        <el-dialog title="反馈信息" :visible.sync="dialogVisible" style="width: 1200px;margin: 0 auto;" :close-on-click-modal="false">
            <div class="box box-align-start feek-back">
                <div class="fb-txt">反馈信息填写：</div>
                <div class="fb-input">
                    <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="textarea">
                    </el-input>
                </div>
                <el-button type="primary" plain size="mini" @click="defaultFb">默认意见</el-button>
            </div>
            <div class="box box-pack-end dialog-btn">
                <el-button type="primary" plain size="medium" @click="sendFB">发送</el-button>
                <el-button type="danger" plain size="medium" @click="() => dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '../../components/common/dytable'

var that = null;
export default {
    data() {
        const { doFeedback } = this;
        return {
            tableLoading: true,
            columns: [
                {
                    key: 'id',
                    title: 'ID'
                },
                {
                    key: 'priority',
                    title: '优先级'
                },
                {
                    key: 'eventName',
                    title: '待办事项名称'
                },
                {
                    key: 'people',
                    title: '创建人'
                },
                {
                    key: 'status',
                    title: '状态'
                },
                {
                    key: 'stage',
                    title: '阶段'
                },
                {
                    key: '',
                    title: '操作',
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-link type="primary">查看详情</el-link>
                                <el-link type="warning" style="margin:0 12px" onClick={() => doFeedback(row)}>反馈</el-link>
                            </div>
                        );
                    }
                },
            ],
            tableData: [
                {
                    id: '001',
                    priority: 1,
                    eventName: '课程审核',
                    people: '张三',
                    status: '未审核',
                    stage: '课程审核'
                }
            ],
            tTotal: 100,
            textarea: '',
            dialogVisible: false
        }
    },
    components: {
        DyTable
    },
    mounted() {
        that = this;
        that.tableLoading = false;
    },
    methods: {
        //默认意见
        defaultFb() {
            that.textarea = '同意';
        },
        //发送反馈
        sendFB() {

        },
        //反馈
        doFeedback() {
            that.dialogVisible = true;
        },
        onCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },
        getList() {

        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header .el-dialog__title {
    display: block;
}

/deep/.el-textarea__inner {
    min-height: 320px;
    width: 350px;
    margin-right: 10px;
}

.feek-back {
    .fb-input {
        margin-right: 10px;
    }
}
</style>